import React from 'react'

import { Box, Text, Link } from '@vividseats/vivid-ui-kit'

import { IMAGES } from '@/constants'

import { BUTTON_LABELS, DISCOVER_REWARD_BENEFITS_URL_STRING } from '../constants'
import styles from '../styles.module.scss'

const BuyMoreEarnMore: React.FC = () => (
    <Box
        display="flex"
        align="center"
        justify="center"
        desktopFlexDirection="row"
        tabletFlexDirection="column"
        mobileFlexDirection="column"
    >
        <Box className={styles.center}>
            <img
                srcSet={`${IMAGES.REWARDS_BUY_MORE_EARN_MORE_MOBILE} 480w, ${IMAGES.REWARDS_BUY_MORE_EARN_MORE_DESKTOP} 800w`}
                sizes="(max-width: 600px) 300px, 400px"
                src={IMAGES.REWARDS_BUY_MORE_EARN_MORE_DESKTOP}
                alt="by more earn more"
                loading="lazy"
            />
        </Box>
        <Box
            display="flex"
            tabletFlexDirection="column"
            mobileFlexDirection="column"
            desktopPaddingLeft={10}
            desktopPaddingTop={2}
            mobilePaddingTop={6}
            className={styles.textBlock}
        >
            <Text as="h2" className={styles.title}>
                Buy more, earn more
            </Text>
            <Box desktopPaddingTop={4} tabletPaddingTop={4} mobilePaddingTop={1} marginBottom={6}>
                <Text>
                    Each ticket you buy gets you closer to your reward. Buy 10 tickets, then cash in your credit toward
                    your 11th ticket.
                </Text>
            </Box>
            <Box display="flex" tabletFlexDirection="column" mobileFlexDirection="column" paddingBottom={10}>
                <Box>
                    <Text className={styles.tip}>
                        <b>Tip: </b>Score tickets for your friend group to earn your free ticket faster!
                    </Text>
                </Box>
                <Box paddingTop={4}>
                    <Link className={styles.button} href={DISCOVER_REWARD_BENEFITS_URL_STRING} isExternal>
                        {BUTTON_LABELS.discoverRewardBenefits}
                    </Link>
                </Box>
            </Box>
        </Box>
    </Box>
)

export default BuyMoreEarnMore
